<template>
  <div
    v-if="isLogin && showCouponBtn"
    class="header-coupon-btn"
    :class="{
      'no-faq-btn': noFaqBtn,
      'has-pay-assistant': isPayAssistantEnabled
    }"
    @click="handleCouponButtonClick"
  >
    <div class="header-coupon-btn-ico" :style="couponIconStyle"></div>
    <em class="red-dot" v-if="showRedDot"></em>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import coupon from '@mixins/officialTopupNew/coupon';

export default {
  name: 'CouponBtn',
  mixins: [coupon],
  props: {
    showCouponBtn: {
      type: Boolean,
      default: false
    }
  },
  methods: {},
  computed: {
    ...mapState({
      lang: state => state.lang,
      isLogin: state => state.login.isLogin,
      faqLangJson: state => state.page.faqLangJson,
      roleId: state => state.roleId
    }),
    ...mapGetters(['isPayAssistantEnabled']),
    noFaqBtn() {
      return !((this.faqLangJson?.[this.lang]?.content || '') && this.roleId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
@import '@assets/scss/officialTopupNew/animate.scss';

.header-coupon-btn {
  box-sizing: border-box;
  z-index: 21;
  position: fixed;
  right: 10px;
  bottom: 440px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  cursor: pointer;

  &.no-faq-btn,
  &.has-pay-assistant {
    bottom: 340px;
  }

  &-ico {
    width: 66px;
    height: 66px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    animation: shake 3s ease infinite;
  }

  .red-dot {
    position: absolute;
    top: -7px;
    right: -7px;
    width: 16px;
    height: 16px;
    background-color: #ff2800;
    border-radius: 50%;
  }
}
</style>
